import { RequestService } from '../../../../../common/services/RequestService';
import { GET_VEHICLES_BY_STATUS } from '../../constants';

export const getActualVehiclesRequest = payload => {
  return RequestService.get(`${GET_VEHICLES_BY_STATUS}actual`);
};
